import styled from "styled-components";

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 1.5rem;
  padding-bottom: 80px;
`;

export const Title = styled.h1`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding-bottom: 10px;
  margin-bottom: 0;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 100%;

  label {
    font-weight: 700;
    font-size: 1rem;
  }

  input,
  select {
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    min-height: 42px;
    width: 100%;
    padding: 5px 12px;
    font-size: 0.95rem;
    background: #fff;
  }

  input:focus,
  select:focus {
    outline: none;
    border-color: #2185d0;
  }

  /* CursosSelector renderiza um Dropdown do Semantic UI dentro de uma Container interna.
     Forçar largura total pra alinhar com o padrão das outras páginas. */
  & > div,
  .ui.dropdown,
  .ui.selection.dropdown {
    width: 100% !important;
  }

  small {
    color: #777;
    font-size: 0.85rem;
  }

  small.error {
    color: #d01919;
  }

  small.counter {
    align-self: flex-end;
  }

  small.counter.over {
    color: #d01919;
    font-weight: 600;
  }
`;

export const Notice = styled.div`
  background: ${({ variant }) =>
    variant === "warning" ? "#fff8e5" : "#e9f4ff"};
  border-left: 4px solid
    ${({ variant }) => (variant === "warning" ? "#f2b500" : "#2185d0")};
  padding: 0.85rem 1.1rem;
  border-radius: 4px;
  font-size: 0.95rem;
  line-height: 1.45;
  width: 100%;

  strong {
    display: block;
    margin-bottom: 0.25rem;
    font-size: 1rem;
  }
`;

export const SubmitButton = styled.button`
  background: #21ba45;
  color: #fff;
  border: 0;
  border-radius: 4px;
  padding: 0.9rem 1.6rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;
  min-width: 240px;

  &:hover:not(:disabled) {
    background: #16ab39;
  }

  &:disabled {
    background: #aaa;
    cursor: not-allowed;
  }
`;
